import { useMemo } from 'react'
import { OrderType } from 'types/checkout'
import { FirebaseDocRefType } from 'firebase'
import { CheckoutItemType } from 'types/checkoutItem'

// 決済ごとの注文から商品別の注文を取得する
const useCheckoutItemsFromOrders = (orders: OrderType[], breadRef?: FirebaseDocRefType): CheckoutItemType[] => {
  return useMemo(() => {
    return orders.reduce((prev: CheckoutItemType[], order: OrderType) => {
      if (typeof breadRef !== 'undefined') {
        return [...prev, ...order.items.filter((item) => item.bread_ref.id === breadRef.id)]
      } else {
        return [...prev, ...order.items]
      }
    }, [])
  }, [orders, breadRef])
}

export default useCheckoutItemsFromOrders
